// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallDisplay_wrapper__2R94p","with-section-nav":"CallDisplay_with-section-nav__36yuS"};